export const DOM_IDS = {
  subscriptionForm: 'email-prefs-form',
  languageSelect: 'hs-localization-select',
  checkBox: subId => `id_${subId}`,
  emailPlaceholder: 'hs-subscriptions-masked-email',
  preLoadStyle: 'hs-susbscriptions-custom-style',
  unsubscribeAll: 'globalunsub',
  archivedType: 'hs-subscriptions-archived-type',
  subscriptionsDefinitions: 'hs-subscriptions-definitions',
  globalResubContainer: 'globalresub-container',
  globalresubButton: 'globalresub2',
  formSubmit: 'submitbutton',
  returnContent: 'hs-subscriptions-return-content',
  managePreferencesButton: 'hs-subscriptions-manage-preferences-button',
  unsubscribeSurvey: 'hs-subscriptions-unsubscribe-survey',
  unsubscribeSurveyOption: 'hs-subscriptions-unsubscribe-survey-option',
  unsubscribeSurveyOtherInput: 'hs-subscriptions-other-option-input',
  otherInputErrorLabel: 'hs-subscriptions-error-label',
  unsubscribeSurveySubmitButton: 'hs-subscriptions-survey-submit-button',
  unsubscribeOtherOption: 'unsubscribe-reason-other',
  unsubscribeSurveyFormControl: 'hs-subscriptions-form-control',
  surveySubmitSuccessMessage: 'hs-subscriptions-survey-submit-success',
  confirmationMessage: 'content',
  confirmationHeader: 'hs-subscriptions-confirmation-header',
  singleUnsubSubscriptionName: 'hs-subscriptions-single-unsub-sub-name',
  unsubSingleConfirmMessage: 'hs-subscriptions-update-single-success',
  trackingConsentSection: 'hs-tracking-consent-section',
  trackingConsentedCheckbox: 'hs-tracking-consented'
};
export const DOM_CLASS_NAMES = {
  loading: 'hs-subscriptions-load',
  uiSpinner: 'hs-subscriptions-custom-spinner',
  loadingMessage: 'hs-subscriptions-custom-message',
  unsubAllConfirmMessage: 'hs-subscriptions-unsub-all-success',
  subConfirmMessage: 'hs-subscriptions-update-success',
  subIds: 'subscription_ids',
  errorLabel: 'hs-subscriptions-error-label',
  inputError: 'hs-subscriptions-input-error'
};
export const QUERY_SELECTORS = {
  inputCheckbox: 'input[type="checkbox"]',
  subscriptionItem: '.email-prefs .item',
  subscriptionItemInner: '.item-inner',
  modifiedEmail: 'input[type="email"][name="modified_email"]',
  email: 'input[type="hidden"][name="email"]',
  resub: 'label[for="globalresub2"]'
};
export let PAGE_TYPE;

// HS_EVENT is used to determine the event taken before displaying Confirm page
(function (PAGE_TYPE) {
  PAGE_TYPE["failure"] = "fallback";
  PAGE_TYPE["confirmation"] = "confirm";
  PAGE_TYPE["preferences"] = "page";
})(PAGE_TYPE || (PAGE_TYPE = {}));
export const HS_EVENT_QUERY_PARAM = 'hssubevent';
export const HS_EVENT_CODE = {
  UNSUBSCRIBE_ALL: 'un',
  MANAGE_PREFERENCES: 'mp',
  UNSUBSCRIBE_SINGLE: 'us',
  UNKNOWN: 'na'
};
export const HS_INPUT_CHAR_LIMIT = 50;